import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";

import { AppHeader } from "../../components/header/header";
import { LoadingIndicator } from "../../components/utilities/loader";
import { useAuth } from "../../services/authentication/authentication.context";
import { useLesson } from "../../services/lessons/lessons.context";
import { formatUrl } from "../../_helpers/parseurl";
import { AppFooter } from "../../components/footer/footer";
import { AppAlert } from "../../components/utilities/app-alert";
import { AddButtonBox } from "../../components/courses/add-box";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";



export const LessonPage = () => {

    const { isLoading, isAdmin, isSuperAdmin, isAuthenticated, user } = useAuth();
    const { courses, categories } = useLesson();
    const navigateTo = useNavigate();

   
    const [onAlert, setOnAlert] = useState();
    const [pageCourses, setPageCourses] = useState([]);
    const [openList, setOpenList] = useState(false);
    const [courseCat, setcourseCat] = useState();

    useEffect(() => {

        (async () => {
            const data = courses;
            if (courseCat) {
                setPageCourses(data?.filter((course) => course?.categoryId?._id === courseCat?._id));
                return;
            } else {
                setPageCourses(data);
            }

            
        })();
    }, [courseCat, courses])

    const toggleDropDown = () => setOpenList((v) => !v);

    return (
        <div className="min-v">
            <AppHeader />
            {isLoading && <LoadingIndicator />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    onAccept={onAlert.onAccept}
                    onReject={onAlert.onReject}
                    closeAlert={() => setOnAlert()}
                />
            )}
            {isAdmin &&
                <AddButtonBox isSuperAdmin={isSuperAdmin} />
            }
            <div className="filter-buttons">
                <button className="cat-drop-button" onClick={toggleDropDown}>
                    <span className="cat-title">
                        --- Filter by Category ----
                    </span>
                    <FontAwesomeIcon
                        icon={faChevronDown}
                        className={classNames('drp-icon', { "rot": openList })}
                    />
                </button>
                <div className={classNames("cat-dropdown", { 'open': openList })}>
                    <button
                        className="cat-btn"
                        onClick={() => {
                            setcourseCat();
                            setOpenList();
                        }}
                    >
                        <span className="cat-caption">All</span>
                        <img className="cat-img" width={30} src={"./sm-logo.png"} alt="" />
                    </button>
                    {categories?.map((category) => (
                        <button
                            className="cat-btn"
                            key={category?._id}
                            onClick={() => {
                                setcourseCat(category);
                                setOpenList(false);
                            }}
                        >
                            <span className="cat-caption">{category?.title}</span>
                            <img className="cat-img" width={30} src={formatUrl(category?.icon)} alt="" />
                        </button>
                    ))}
                </div>
            </div>
            <div className={classNames("cap", "lg-txt", 'flx-cnt-pg')}>Featured courses</div>
            <div className={classNames("cap", "lg-txt", "flx-cnt-pg")}>{courseCat?.title}</div>
            <div className="sm-sp" />
            {courses?.length > 0 ?
                (<div className="course-area">
                    {pageCourses?.map((course, key) => (
                        <div
                            className="course-unit"
                            onClick={() => {
                                if (!isAuthenticated) {
                                    setOnAlert({
                                        caption: "Unauthorized!",
                                        message: "Please sign in to access the course content",
                                        accept: "OK",
                                        reject: "Cancel",
                                        onAccept: () => navigateTo("/login"),
                                        onReject: () => setOnAlert()
                                    });
                                    return;
                                }
                                if (user?.role === "user" && !user?.placed) {
                                    navigateTo("/placement");
                                    return;
                                }
                                navigateTo("/course", { state: { course } });
                            }}
                            key={key}
                        >
                            <img className="course-img" src={formatUrl(course?.poster)} alt="" />
                            <div className="course-info">
                                <div className="course-caption">{course?.title}</div>
                                <div className="course-slogan">{course?.slogan}</div>
                                <div className="instr">{course?.instructor}</div>
                                <div className="course-cat">
                                    <img src={formatUrl(course.categoryId?.icon)} alt="" width={16} />
                                    <span className="cat-descr">{course.categoryId?.title}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>) :
                (
                    <div className={classNames("cap", "lg-txt", 'flx-cnt-pg')}>
                        No courses available for now
                    </div>
                )
            }
            <AppFooter />
        </div>
    )
}